/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const NotificationActionType = zod.enum(['shift.view', 'shift.offer.review', 'employee.view', 'time_off.request.view', 'time_off.request.respond']);

export type NotificationActionType = zod.input<typeof NotificationActionType>;
export type NotificationActionTypeOutput = zod.output<typeof NotificationActionType>;
